import React, { memo } from 'react';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';
import Checkbox from '../../helpers/Checkbox';
import FormGroup from '../../helpers/FormGroup';

import style from './style.module.css';

const GenerateOnlineApprovalListPopup = props => {
  const footer = (
    <Button
      key="run"
      className="btn-primary"
      disabled={props.disabled}
      onClick={props.onGenerateOnlineApprovalList}
    >
      Preview
    </Button>
  );

  return (
    <Popup className={style.host} footer={footer} header="Online Approval List" id="generateOnlineApprovalListPopup">
      <p className="form-section-label">Optional Fields</p>
      <div className="row">
        <FormGroup className="col-sm-12 mb0">
          <Checkbox label="Products" name="products" onChange={props.onChange} />
        </FormGroup>
        <FormGroup className="col-sm-12 mb0">
          <Checkbox label="Markets" name="markets" onChange={props.onChange} />
        </FormGroup>
        <FormGroup className="col-sm-12 mb0">
          <Checkbox label="Facilities" name="facilities" onChange={props.onChange} />
        </FormGroup>
        <FormGroup className="col-sm-12 mb0">
          <Checkbox label="Custom Field" name="custom_fields" onChange={props.onChange} />
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(GenerateOnlineApprovalListPopup);
